
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[section]/[city]/[slug]/book",
      function () {
        return require("private-next-pages/[section]/[city]/[slug]/book.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[section]/[city]/[slug]/book"])
      });
    }
  